@<template>
  <div>
    <div class="newestBtn">
      <div class="newestBtn-play">
        <div class="newestBtn-input">
          <input type="button" v-for="(button,index) in buttons" v-bind:value=button.value
                 :class="{active:button.isActive}" @click="btnClick(button)">
        </div>
        <div class="line"></div>
      </div>
    </div>

    <div class="messageContent">
      <div class="messageContent-play">
        <div class="content-area">
          <div v-for="messageContent in itemsNews" class="content">
            <div class="titleBox">
              <li style="list-style-position: inside">
                <a href="#" style="color: #000;" class="newContent" @click="flag=true,newsObj=messageContent;
                   readNews(messageContent.id,messageContent.state)">
                  {{messageContent.title}}
                </a>
              </li>
            </div>

            <div class="timeBox">
              <span class="spanOne">
                <template v-if="messageContent.state == '1'">{{$t('i.news.yes')}}</template>
                <template v-else>{{$t('i.news.no')}}</template>
              </span>
              <span class="spanTwo">{{messageContent.time}}</span>
            </div>
            <div class="line2"></div>

          </div>
        </div>
        <div class="newsPopupBox">
          <news-popup v-show="flag" :is_show_course ="is_show_course" :newCourse = "newCourse" :show="flag" :newsObj="newsObj" @close="()=>flag = false"></news-popup>
        </div>
      </div>
    </div>
    <div class="control">
      <div class="control-play">
        <Page :total="totalRow" :page-size="pageSize" :current="pageNumber"  style="text-align:center;"
              @on-change="pageNumberChange"  @on-page-size-change='pageSizeChange'  show-sizer show-total/>
      </div>
    </div>
<!--
    <base-text></base-text>
-->
  </div>
</template>

<script>
  import NewsPopup from "../../newsPopup/newsPopup";
  import BaseText from "../../../common/components/baseText";
  export default {
    name: "messageContent",
    components: {BaseText, NewsPopup},
    data(){
      return{
        pageSize : this.Constants.pageSize , //每页显示10条数据
        pageNumber : this.Constants.pageCurrent, //当前页码
        totalRow : 0, //总记录数
        totalPage : 0,//总页数
        flag: false,
        newsObj: '',
        itemsNews: [],
        status:'',
        is_show_course:false,
        newCourse:[],
        buttons:[
          {
            value: this.$t('i.news.all'),
            key:'0',
            isActive : true
          },
          {
            value: this.$t('i.news.yes'),
            key:'1',
            isActive : false
          },
          {
            value: this.$t('i.news.no'),
            key:'2',
            isActive : false
          }
        ]
      }
    },
    methods: {
      async getList(){
        const json = await this.RequestUtil.request("/front/news/index?pageCurrent=" + this.pageNumber + "&pageSize=" + this.pageSize + "&status="+this.status);
        if(json){
          if(json.statusCode == this.Constants.statusCode.ok){
            this.itemsNews = json.datas.list;
            this.pageSize = json.datas.pageSize;
            this.pageNumber = json.datas.pageNumber;
            this.totalRow = json.datas.totalRow;
            this.totalPage = json.datas.totalPage;
          }
        }
      },
      pageNumberChange(value){
        this.pageNumber = value;
        this.getList()
      },
      pageSizeChange(value){
        this.pageSize = value;
        this.getList()
      },
      async btnClick(data){
        this.buttons.forEach(function(obj){
          obj.isActive = false;
        });
        data.isActive = !data.isActive;
        this.status = data.key;
        this.pageSize = this.Constants.pageSize;
        this.pageNumber = this.Constants.pageCurrent;
        this.totalRow = 0;
        this.totalPage = 0;
        this.getList();
      },
      async readNews(id,state){
        const json = await this.RequestUtil.request("/front/news/showNewsCourse?id=" + id);
        if(json){
          if(json.statusCode == this.Constants.statusCode.ok){
            if(json.datas.list.length == 0){
              this.is_show_course = false;
            }else{
              this.is_show_course = true;
              this.newCourse = json.datas.list;
            }
          }
        }
        if(state == "0"){
          const json = await this.RequestUtil.request("/front/news/readNews?id=" + id);
          if(json){
            if(json.statusCode == this.Constants.statusCode.ok){
              this.getList();
            }
          }
        }
      }
    },
    mounted () {
      // this.getList()
    },
    created() {
      debugger
      this.getList()
    }
  }
</script>

<style scoped>

  .newestBtn{
    width: 100%;
    height: 75px;
  }
  .newestBtn-play{
    width: 1150px;
    height: 75px;
    margin: 0 auto;
    padding-top: 1px;
  }
  .newestBtn-input{
    margin-top: 20px;
    font-size: 22px;
    margin-left: 45px;
  }
  .newestBtn-input input[type="button"]{
    width: 80px;
    height: 35px;
    background-color: #fff;
    border: 0;
    border-radius: 5px;
    cursor: pointer;
    font-size: 21px;
    margin-right: 10px;
  }
  .active{
    background-color: #ff0000!important;
  }
  .line{
    width: 1025px;
    height: 1px;
    background-color: #c7c7c7;
    margin-top: 15px;
    margin-left: 62px;
  }
  .messageContent{
    width: 100%;
    height: auto;
  }
  .messageContent-play{
    width: 1025px;
    height: auto;
    margin: 0 auto;

  }
  .content-area{
    width: 1025px;
    height: auto;
    min-height: 400px;

  }
  .content{
    width: 1025px;
    height: 40px;
  }
  .titleBox{
    width: 820px;
    height: 40px;
    overflow: hidden;
    float: left;
    margin-left: 5px;
  }
  .newContent{
    font-size: 18px;
    line-height: 40px;
  }
  .timeBox{
    width: 200px;
    height: 40px;
    float: right;
    position: relative;
  }
  .spanOne{
    line-height: 40px;
    color: #828282;
    position: absolute;
    left: 5px
  }
  .spanTwo{
    line-height: 40px;
    color: #828282;
    position: absolute;
    left: 80px
  }
  .line2{
    width: 1025px;
    height: 1px;
    background-color: #d3d7d8;
    float: left;
  }
  .control{
    width: 100%;
    height: 35px;
    margin-top: 30px;
  }
  .control-play{
    width: 1025px;
    height: 35px;
    margin: 0 auto;
    overflow: hidden;
  }
  .newsPopupBox{
    position: absolute;
    z-index: 110;
  }
</style>



// WEBPACK FOOTER //
// src/pages/news/components/messageContent.vue